import { Action } from '@ngrx/store';
import { CompareREPORTState } from '@core/states/compare-report.state';

export const ADD_COMPARE_REPORT = '[COMPARE_REPORT] Add';
export const REMOVE_COMPARE_REPORT = '[COMPARE_REPORT] Remove';
export const UPDATE_COMPARE_REPORT_COUNT = '[COMPARE_REPORT] Update Count';
export const UPDATE_COMPARE_REPORT_SELECTED_CONNECTIONS_OBJS = '[COMPARE_REPORT] Update Selected Connections Objs';
export const UPDATE_COMPARE_REPORT_SELECTED_CONNECTIONS_IDS = '[COMPARE_REPORT] Update Selected Connections IDs';
export const UPDATE_COMPARE_REPORT_PROPERTIES = '[COMPARE_REPORT] Update Properties';
export const UPDATE_COMPARE_REPORT_PROPERTIES_OBJ = '[COMPARE_REPORT] Update Properties Obj';
export const UPDATE_COMPARE_REPORT_CONNECTIONS_LIST = '[COMPARE_REPORT] Update Connections list';
export const SET_COMPARE_REPORT_CONNECTIONS = '[COMPARE_REPORT] set connections';

export class AddCompareREPORT implements Action {
	readonly type = ADD_COMPARE_REPORT;

	constructor(public payload: CompareREPORTState) {
	}
}

export class RemoveCompareREPORT implements Action {
	readonly type = REMOVE_COMPARE_REPORT;

	constructor(public payload: number) {
	}
}

export class UpdateCompareREPORTCount implements Action {
	readonly type = UPDATE_COMPARE_REPORT_COUNT;

	constructor(public payload: { count: string }) {
	}
}

export class UpdateCompareREPORTSelectedConnectionsObjs implements Action {
	readonly type = UPDATE_COMPARE_REPORT_SELECTED_CONNECTIONS_OBJS;

	constructor(public payload: { selected_connections_objs: Array<any> }) {
	}
}

export class UpdateCompareREPORTSelectedConnectionsIDs implements Action {
	readonly type = UPDATE_COMPARE_REPORT_SELECTED_CONNECTIONS_IDS;

	constructor(public payload: { selected_connections_ids: string }) {
	}
}

export class UpdateCompareREPORTProperties implements Action {
	readonly type = UPDATE_COMPARE_REPORT_PROPERTIES;

	constructor(public payload: { properties: object }) {
	}
}

export class UpdateCompareREPORTPropertiesObj implements Action {
	readonly type = UPDATE_COMPARE_REPORT_PROPERTIES_OBJ;

	constructor(public payload: { properties_obj: object }) {
	}
}

export class UpdateCompareREPORTConnectionsList implements Action {
	readonly type = UPDATE_COMPARE_REPORT_CONNECTIONS_LIST;

	constructor(public payload: { connections_list: object }) {
	}
}

export class SetCompareReportConnections implements Action {
	readonly type = SET_COMPARE_REPORT_CONNECTIONS;

	constructor(public payload: any) {
	}
}

export type Actions =
	AddCompareREPORT |
	RemoveCompareREPORT |
	UpdateCompareREPORTConnectionsList |
	UpdateCompareREPORTSelectedConnectionsIDs |
	UpdateCompareREPORTSelectedConnectionsObjs |
	UpdateCompareREPORTCount |
	UpdateCompareREPORTProperties |
	UpdateCompareREPORTPropertiesObj |
	SetCompareReportConnections;
